import {
  Search,
  CheckCircle,
  Clock,
} from "lucide-react";

import { SectionCard } from "../../../Component/AdminComponents/SectionCard";
import RefreshButton from "../../../Component/Common/RefreshButton";
import Pagination from "../../../Component/Common/Pagination";
import RegularLoader from "../../../Component/Loader/RegularLoader";

import { useEffect, useState } from "react";
import { BASE_URL } from "../../../config/api";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function StepsProgressTable({
  loading,
  search,
  searchRetailers,
  fetchRetailers,
  currentPage,
  totalPages,
  setCurrentPage,
  paginatedRetailers,
  navigate,
}) {

  const internalNavigate = useNavigate();
  const navigateTo = navigate || internalNavigate;
  const [internalRetailers, setInternalRetailers] = useState([]);
  const [internalLoading, setInternalLoading] = useState(false);

  const [internalCurrentPage, setInternalCurrentPage] = useState(1);
  const [internalTotalPages, setInternalTotalPages] = useState(1);
  const [internalTotalRecords, setInternalTotalRecords] = useState(0);

  


const hasPropData =
  Array.isArray(paginatedRetailers) &&
  paginatedRetailers.length > 0; 

  

  const fetchInternalRetailers = async () => {

    try {

      setInternalLoading(true);

      const session = JSON.parse(
        localStorage.getItem(
          "authUserData"
        ) || "{}"
      );

      const role =
        session?.role;

      const id =
        session?.id;

      const state =
        session?.state;

      const district =
        session?.district;

      const locationMode =
        session?.location_mode;

      const handle =
        session?.handle || [];

      const params = {
        role: 5,

        page:
          internalCurrentPage,
      };

      // ROLE 2
      if (role === 2) {
        params.company_id = id;
      }

      // ROLE 3
      if (role === 3) {

        if (
          Array.isArray(handle) &&
          handle.includes("AGENT")
        ) {

          if (
            locationMode ===
              "state" &&
            state
          ) {
            params.state = state;
          }

          if (
            locationMode ===
              "district" &&
            district
          ) {
            params.district =
              district;
          }
        }
      }

      // ROLE 4
      if (role === 4) {
        params.agent_id = id;
      }

      // SEARCH
      if (search?.trim()) {
        params.search_value =
          search;
      }

      const response =
        await axios.get(
          `${BASE_URL}common/get-users`,
          {
            params,

            headers: {
              Accept:
                "application/json",

              "Content-Type":
                "application/json",
            },
          }
        );

      const json =
        response.data;

      if (json?.status) {

        setInternalRetailers(
          json.data || []
        );

        setInternalCurrentPage(
          json?.pagination
            ?.current_page || 1
        );

        setInternalTotalPages(
          json?.pagination
            ?.last_page || 1
        );

        setInternalTotalRecords(
          json?.pagination
            ?.total || 0
        );
      }

    } catch (err) {

      console.error(
        "StepsProgressTable Fetch Error:",
        err
      );

    } finally {

      setInternalLoading(false);

    }
  };

useEffect(() => {
  if (!hasPropData) {
    fetchInternalRetailers();
  }
}, [internalCurrentPage, search]);

const retailersData = hasPropData
  ? paginatedRetailers
  : internalRetailers;

  const getRetailerSteps = (r) => {
    const step1 =
      r.is_mail_verified === 1 &&
      r.is_wa_verified === 1;

    const step2 =
      r.is_payment_success === 1;

    const step3 =
      r.pan_verified === 1 &&
      r.pan_json !== null;

    const step4 =
      r.business_type === "unregistered"
        ? true
        : r.gst_verified === 1 &&
          r.gst_json !== null;

    const step5 =
      r.bank_verified === 1 &&
      r.bank_json !== null;

    const step6 =
      r.is_verified === 7;

    const step7 =
      r.esign_verified === 1;

    return [
      {
        label: "Mail + WhatsApp Verified",
        done: step1,
      },
      {
        label: "Payment Success",
        done: step2,
      },
      {
        label: "PAN Verified",
        done: step3,
      },
      {
        label: "GST Verified",
        done: step4,
      },
      {
        label: "Bank Verified",
        done: step5,
      },
      {
        label: "Admin Verification",
        done: step6,
      },
      {
        label: "E-Sign Completed",
        done: step7,
      },
    ];
  };

  const refreshretailer = fetchRetailers || fetchInternalRetailers;

  return (
    <SectionCard
      title="Retailer Onboarding Progress"
      right={
        <div className="flex items-center gap-2 text-[11px]">
          <div className="flex items-center gap-1 px-2 py-1 rounded-xl border border-slate-200 bg-slate-50">
            <Search className="w-5 h-5" />

            <input
              placeholder="Search retailer..."
              className="bg-transparent text-[11px] outline-none"
              value={search}
              onChange={(e) =>
                searchRetailers(e.target.value)
              }
            />
          </div>

          <div className="hidden lg:block">
            <RefreshButton
              onClick={() =>
                refreshretailer(currentPage)
              }
            />
          </div>
        </div>
      }
    >
      {(loading || internalLoading) && (
        <RegularLoader />
      )}

      {!(loading || internalLoading) && (
        <>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm text-left border border-slate-200 rounded-lg">
              <thead className="bg-slate-50 border-b">
                <tr>
                  <th className="px-4 py-2">
                    Retailer
                  </th>

                  <th className="px-4 py-2 text-center">
                    Mail + WA
                  </th>

                  <th className="px-4 py-2 text-center">
                    Payment
                  </th>

                  <th className="px-4 py-2 text-center">
                    PAN
                  </th>

                  <th className="px-4 py-2 text-center">
                    GST
                  </th>

                  <th className="px-4 py-2 text-center">
                    Bank
                  </th>

                  <th className="px-4 py-2 text-center">
                    Agreement
                  </th>

                  <th className="px-4 py-2 text-center">
                    E-Sign
                  </th>
                </tr>
              </thead>

              <tbody>
                {retailersData.map((r) => {
                  const retailerData = r.raw || r;

                  const steps =
                    getRetailerSteps(retailerData);

                  return (
                    <tr
                      key={r.id}
                      className="border-b hover:bg-slate-50 cursor-pointer"
                      onClick={() =>
                        navigateTo(`/user/${r.id}`, {
                          state: {
                            entityType: "retailer",
                            data: r,
                          },
                        })
                      }
                    >
                      <td className="px-4 py-2">
                        <div className="font-semibold">
                          {r.business_name}
                        </div>

                        <div className="text-xs text-slate-500">
                          {r.company_code}
                        </div>
                      </td>

                      {steps.map((step) => (
                        <td
                          key={step.label}
                          className="px-4 py-2 text-center"
                        >
                          {step.done ? (
                            <CheckCircle
                              size={18}
                              className="text-green-600 mx-auto"
                            />
                          ) : (
                            <Clock
                              size={18}
                              className="text-amber-500 mx-auto"
                            />
                          )}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {(hasPropData ? totalPages : internalTotalPages) > 1 && (
            <div className="mt-4 flex justify-end">
              <Pagination
                currentPage={
                  hasPropData
                    ? currentPage
                    : internalCurrentPage
                }
                totalPages={
                  hasPropData
                    ? totalPages
                    : internalTotalPages
                }
                onPageChange={
                  hasPropData
                    ? setCurrentPage
                    : setInternalCurrentPage
                }
              />
            </div>
          )}
        </>
      )}
    </SectionCard>
  );
}